import React from 'react';
import Layout from '../../components/Layout';
import { Layout as LayoutIcon, ShoppingBag, Calendar, MessageSquare, FileText, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';

const contentTypes = [
  { id: 'sections', name: 'Sections', icon: LayoutIcon, path: '/admin/site-sections' },
  { id: 'events', name: 'Événements', icon: Calendar, path: '/admin/site-events' },
  { id: 'testimonials', name: 'Témoignages', icon: MessageSquare, path: '/admin/site-testimonials' },
  { id: 'statistiques', name: 'stats', icon: MessageSquare, path: '/admin/site-stats' },
  { id: 'products', name: 'Produits', icon: ShoppingBag, path: '/admin/site-products' },
  { id: 'news', name: 'Actualités', icon: FileText, path: '/admin/site-news' },
  { id: 'navigation', name: 'Navigation', icon: Menu, path: '/admin/site-navigation' },
  { id: 'plans', name: 'Plans', icon: Menu, path: '/admin/site-plans' }
];

const AdminSiteContent: React.FC = () => {
  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-gray-900">Gestion du Contenu du Site</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contentTypes.map(type => {
            const Icon = type.icon;
            return (
              <Link
                key={type.id}
                to={type.path}
                className="flex items-center p-6 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-200"
              >
                <div className="flex-shrink-0 bg-[#FFB639]/15 text-[#FFB639] rounded-full p-3">
                  <Icon className="h-6 w-6" />
                </div>
                <div className="ml-4">
                  <h2 className="text-lg font-semibold text-gray-900">{type.name}</h2>
                  <p className="text-sm text-gray-500">Gérer les {type.name.toLowerCase()} du site.</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default AdminSiteContent;
